import type { CmsProps } from '../../../types/cms'
import styled from '@emotion/styled'
import { Background } from '../../surfaces/background'

export const ButtonContainer = styled.div<CmsProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 2rem 0rem;
  button {
    padding: 0rem 1rem;
    border: none;
    background: none;
    cursor: pointer;
    font-family: inherit;
  }
`

export const TabLabel = styled.p<{ isActive?: boolean }>`
  font-size: 1.4rem;
  color: ${({ isActive, theme }) =>
    isActive ? theme.palette.primary.main : 'rgba(7, 26, 42, 0.6)'};
  font-weight: ${({ isActive }) => (isActive ? 700 : 400)};
  border-bottom: ${({ isActive, theme }) =>
    isActive ? `3px solid ${theme.palette.primary.light}` : 'none'};
`

export const TreatmentAreasContainer = styled(Background)<CmsProps>`
  h2 {
    color: #000;
  }
`
